import React, { useState } from 'react';
import FormSurvey from './FormSurvey';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { SURVEY_CREATE } from 'graphql/mutations';
import { useMutation } from '@apollo/client';
import useNotificationAlert from 'hooks/useNotificationAlert';
import { logoAlignmentToGraphqlLogoAlignmentMap } from 'constants/global';
import useSurveyType from 'hooks/useSurveyType';
import ModalNoAccess from 'components/modals/ModalNoAccess';
import { useSelector } from 'react-redux';

const AddSurvey = () => {
  const [redirectTo, setRedirectTo] = useState('');
  const [visibilityControl, setVisibilityControl] = useState(false);

  const { me } = useSelector((state) => state.auth);

  const { surveyFullPath, isGatherTemplate, isUserTemplate, listLabel } = useSurveyType();

  const [surveyCreate, { loading: isLoadingSave }] = useMutation(SURVEY_CREATE);

  const { show: showNotificationAlert } = useNotificationAlert({
    place: 'br'
  });

  const onSubmit = async (data) => {
    if (!visibilityControl) {
      data.visibility = null;
    } else if (visibilityControl && !data.visibility) {
      data.visibility = '[]';
    } else {
      data.visibility = JSON.stringify(data.visibility);
    }
    try {
      const {
        name,
        backgroundColor,
        backgroundImage,
        buttonColor,
        buttonTextColor,
        font,
        fontColor,
        restartSurvey,
        showingAverageRating,
        visibility,
        logo,
        logoAlignment,
        tags
      } = data;

      const resSurveyCreate = await surveyCreate({
        variables: {
          input: {
            name,
            logo,
            logoAlignment: logoAlignmentToGraphqlLogoAlignmentMap[logoAlignment],
            backgroundColor,
            backgroundImage,
            buttonColor,
            buttonTextColor,
            font,
            fontColor,
            restartSurvey,
            showingAverageRating,
            visibility,
            status: 'DRAFT',
            active: true,
            isGatherTemplate: isGatherTemplate || false,
            isTemplate: isUserTemplate || false,
            tags: tags?.map((elm) => elm.text) || undefined
          }
        }
      });

      showNotificationAlert({
        title: 'Success',
        message: 'You have added a survey successfully'
      });

      setRedirectTo(`${surveyFullPath}/${resSurveyCreate.data.surveyCreate.id}/edit`);
    } catch (err) {
      switch (err.message) {
        default:
          showNotificationAlert({
            type: 'danger',
            title: 'Failed',
            message: err.message
          });
          break;
      }
    }
  };

  const isTemplate = isGatherTemplate || isUserTemplate;

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <>
      <ModalNoAccess isShow={me?.visibility === 'RESULTS_ONLY'} />
      <SimpleHeader
        name={isTemplate ? 'Create Template' : 'Create'}
        description={`Use the functions below to make the changes that you need - quickly and easily.`}
        parents={[{ to: surveyFullPath, label: listLabel }]}
        rightElements={
          <Link
            to={surveyFullPath}
            className="btn btn-neutral btn-sm rounded-pill"
            color="default"
            size="sm">
            Back
          </Link>
        }
      />
      <FormSurvey
        onSubmit={onSubmit}
        type="add"
        isLoadingSave={isLoadingSave}
        onChangeVisibilityControl={(val) => {
          setVisibilityControl(val);
        }}
        showVisibilityInput={visibilityControl}
      />
    </>
  );
};

export default AddSurvey;
